import { IApplicationState } from '../../types/redux';
import { IPaymentMethod } from '../../types/redux/paymentMethods';
import { selectActivePaymentMethodId } from './selectActivePaymentMethodId';
import { selectPaymentMethodById } from './selectPaymentMethodById';

export const selectActivePaymentMethod = (state: IApplicationState): IPaymentMethod => {
  const activeMethodId = selectActivePaymentMethodId(state);

  return selectPaymentMethodById(activeMethodId)(state);
};
